import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';

export default function getBlockSendersConfirmTitleAndSubtext(
    emailAddresses: EmailAddressWrapper[]
): [string, string] {
    return [title(emailAddresses), subtext(emailAddresses)];
}

function title(emailAddresses: EmailAddressWrapper[]): string {
    return formatSenders(
        emailAddresses,
        e => e.Name,
        strings.blockSendersTitle,
        strings.blockTwoSendersTitle,
        strings.blockThreeSendersTitle,
        strings.blockFourToSixSendersTitle,
        strings.blockSevenOrMoreSendersTitle
    );
}

function subtext(emailAddresses: EmailAddressWrapper[]): string {
    return formatSenders(
        emailAddresses,
        e => e.EmailAddress,
        strings.blockSendersSubtext,
        strings.blockTwoSendersSubtext,
        strings.blockThreeSendersSubtext,
        strings.blockFourToSixSendersSubtext,
        strings.blockSevenOrMoreSendersSubtext
    );
}

function formatSenders(
    emailAddresses: EmailAddressWrapper[],
    toText: (e: EmailAddressWrapper) => string,
    oneSender: string,
    twoSenders: string,
    threeSenders: string,
    fourToSixSenders: string,
    sevenOrMoreSenders: string
): string {
    switch (emailAddresses.length) {
        case 0:
            throw new Error('formatSenders: no email addresses');
        case 1:
            return format(oneSender, toText(emailAddresses[0]));
        case 2:
            return format(twoSenders, toText(emailAddresses[0]), toText(emailAddresses[1]));
        case 3:
            return format(threeSenders, toText(emailAddresses[0]), toText(emailAddresses[1]));
        case 4:
        case 5:
        case 6:
            return format(
                fourToSixSenders,
                toText(emailAddresses[0]),
                toText(emailAddresses[1]),
                emailAddresses.length - 2
            );
        default:
            return format(
                sevenOrMoreSenders,
                toText(emailAddresses[0]),
                toText(emailAddresses[1]),
                emailAddresses.length - 2
            );
    }
}
